var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { defineComponent, h, ref, resolveComponent, createCommentVNode, provide, computed, inject, reactive, watch, nextTick, onMounted } from 'vue';
import XEUtils from 'xe-utils';
import GlobalConfig from '../../v-x-e-table/src/conf';
import { VXETable } from '../../v-x-e-table';
import { getFuncText, isEnableConf, eqEmptyValue } from '../../tools/utils';
import { errLog, warnLog } from '../../tools/log';
import { scrollToView } from '../../tools/dom';
import { createItem, handleFieldOrItem, isHiddenItem, isActivetem } from './util';
import { useSize } from '../../hooks/size';
import VxeFormConfigItem from './form-config-item';
import VxeLoading from '../../loading/index';
import { getSlotVNs } from '../../tools/vn';
var Rule = /** @class */ (function () {
    function Rule(rule) {
        Object.assign(this, {
            $options: rule,
            required: rule.required,
            min: rule.min,
            max: rule.min,
            type: rule.type,
            pattern: rule.pattern,
            validator: rule.validator,
            trigger: rule.trigger,
            maxWidth: rule.maxWidth
        });
    }
    Object.defineProperty(Rule.prototype, "content", {
        get: function () {
            return getFuncText(this.$options.content || this.$options.message);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Rule.prototype, "message", {
        get: function () {
            return this.content;
        },
        enumerable: false,
        configurable: true
    });
    return Rule;
}());
var validErrorRuleValue = function (rule, val) {
    var type = rule.type, min = rule.min, max = rule.max, pattern = rule.pattern;
    var isNumType = type === 'number';
    var numVal = isNumType ? XEUtils.toNumber(val) : XEUtils.getSize(val);
    // 判断数值
    if (isNumType && isNaN(val)) {
        return true;
    }
    // 如果存在 min，判断最小值
    if (!XEUtils.eqNull(min) && numVal < XEUtils.toNumber(min)) {
        return true;
    }
    // 如果存在 max，判断最大值
    if (!XEUtils.eqNull(max) && numVal > XEUtils.toNumber(max)) {
        return true;
    }
    // 如果存在 pattern，正则校验
    if (pattern && !(XEUtils.isRegExp(pattern) ? pattern : new RegExp(pattern)).test(val)) {
        return true;
    }
    return false;
};
function getResetValue(value, resetValue) {
    if (XEUtils.isArray(value)) {
        resetValue = [];
    }
    return resetValue;
}
export default defineComponent({
    name: 'VxeForm',
    props: {
        collapseStatus: { type: Boolean, default: true },
        loading: Boolean,
        data: Object,
        size: { type: String, default: function () { return GlobalConfig.form.size || GlobalConfig.size; } },
        span: { type: [String, Number], default: function () { return GlobalConfig.form.span; } },
        align: { type: String, default: function () { return GlobalConfig.form.align; } },
        titleAlign: { type: String, default: function () { return GlobalConfig.form.titleAlign; } },
        titleWidth: { type: [String, Number], default: function () { return GlobalConfig.form.titleWidth; } },
        titleColon: { type: Boolean, default: function () { return GlobalConfig.form.titleColon; } },
        titleAsterisk: { type: Boolean, default: function () { return GlobalConfig.form.titleAsterisk; } },
        titleOverflow: { type: [Boolean, String], default: null },
        vertical: {
            type: Boolean,
            default: null
        },
        className: [String, Function],
        readonly: Boolean,
        items: Array,
        rules: Object,
        preventSubmit: { type: Boolean, default: function () { return GlobalConfig.form.preventSubmit; } },
        validConfig: Object,
        tooltipConfig: Object,
        customLayout: { type: Boolean, default: function () { return GlobalConfig.form.customLayout; } }
    },
    emits: [
        'update:collapseStatus',
        'collapse',
        'toggle-collapse',
        'submit',
        'submit-invalid',
        'reset'
    ],
    setup: function (props, context) {
        var hasUseTooltip = VXETable.tooltip;
        var slots = context.slots, emit = context.emit;
        var xID = XEUtils.uniqueId();
        var computeSize = useSize(props);
        var reactData = reactive({
            collapseAll: props.collapseStatus,
            staticItems: [],
            formItems: []
        });
        var internalData = reactive({
            tooltipTimeout: null,
            tooltipStore: {
                item: null,
                visible: false
            }
        });
        var $xegrid = inject('$xegrid', null);
        var refElem = ref();
        var refTooltip = ref();
        var formMethods = {};
        var computeValidOpts = computed(function () {
            return Object.assign({}, GlobalConfig.form.validConfig, props.validConfig);
        });
        var computeTooltipOpts = computed(function () {
            return Object.assign({}, GlobalConfig.tooltip, GlobalConfig.form.tooltipConfig, props.tooltipConfig);
        });
        var refMaps = {
            refElem: refElem
        };
        var computeMaps = {
            computeSize: computeSize,
            computeValidOpts: computeValidOpts,
            computeTooltipOpts: computeTooltipOpts
        };
        var $xeform = {
            xID: xID,
            props: props,
            context: context,
            reactData: reactData,
            xegrid: $xegrid,
            getRefMaps: function () { return refMaps; },
            getComputeMaps: function () { return computeMaps; }
        };
        var callSlot = function (slotFunc, params) {
            if (slotFunc) {
                if (XEUtils.isString(slotFunc)) {
                    slotFunc = slots[slotFunc] || null;
                }
                if (XEUtils.isFunction(slotFunc)) {
                    return getSlotVNs(slotFunc(params));
                }
            }
            return [];
        };
        var loadItem = function (list) {
            if (list.length) {
                if (process.env.NODE_ENV === 'development') {
                    list.forEach(function (item) {
                        if (item.slots) {
                            XEUtils.each(item.slots, function (func) {
                                if (!XEUtils.isFunction(func)) {
                                    if (!slots[func]) {
                                        errLog('vxe.error.notSlot', [func]);
                                    }
                                }
                            });
                        }
                    });
                }
                reactData.staticItems = XEUtils.mapTree(list, function (item) { return createItem($xeform, item); }, { children: 'children' });
            }
            return nextTick();
        };
        var getItems = function () {
            var itemList = [];
            XEUtils.eachTree(reactData.formItems, function (item) {
                itemList.push(item);
            }, { children: 'children' });
            return itemList;
        };
        var getItemByField = function (field) {
            var rest = XEUtils.findTree(reactData.formItems, function (item) { return item.field === field; }, { children: 'children' });
            return rest ? rest.item : null;
        };
        var getCollapseStatus = function () {
            return reactData.collapseAll;
        };
        var toggleCollapse = function () {
            var status = !getCollapseStatus();
            reactData.collapseAll = status;
            emit('update:collapseStatus', status);
            return nextTick();
        };
        var toggleCollapseEvent = function (evnt) {
            toggleCollapse();
            var status = getCollapseStatus();
            formMethods.dispatchEvent('toggle-collapse', { status: status, collapse: status, data: props.data }, evnt);
            formMethods.dispatchEvent('collapse', { status: status, collapse: status, data: props.data }, evnt);
        };
        var clearValidate = function (fieldOrItem) {
            if (fieldOrItem) {
                var fields = fieldOrItem;
                if (!XEUtils.isArray(fieldOrItem)) {
                    fields = [fieldOrItem];
                }
                fields.forEach(function (field) {
                    if (field) {
                        var item = handleFieldOrItem($xeform, field);
                        if (item) {
                            item.showError = false;
                        }
                    }
                });
            }
            else {
                getItems().forEach(function (item) {
                    item.showError = false;
                });
            }
            return nextTick();
        };
        var reset = function () {
            var data = props.data;
            var itemList = getItems();
            if (data) {
                itemList.forEach(function (item) {
                    var field = item.field, resetValue = item.resetValue, itemRender = item.itemRender;
                    if (isEnableConf(itemRender)) {
                        var compConf = VXETable.renderer.get(itemRender.name);
                        if (compConf && compConf.itemResetMethod) {
                            compConf.itemResetMethod({ data: data, field: field, property: field, item: item, $form: $xeform, $grid: $xeform.xegrid });
                        }
                        else if (field) {
                            XEUtils.set(data, field, resetValue === null ? getResetValue(XEUtils.get(data, field), undefined) : XEUtils.clone(resetValue, true));
                        }
                    }
                });
            }
            return clearValidate();
        };
        var resetEvent = function (evnt) {
            evnt.preventDefault();
            reset();
            formMethods.dispatchEvent('reset', { data: props.data }, evnt);
        };
        var handleFocus = function (fields) {
            var el = refElem.value;
            for (var i = 0; i < fields.length; i++) {
                var property = fields[i];
                var item = getItemByField(property);
                if (item && isEnableConf(item.itemRender)) {
                    var itemRender = item.itemRender;
                    var compConf = VXETable.renderer.get(itemRender.name);
                    var inputElem = null;
                    // 定位到第一个
                    if (!i) {
                        scrollToView(el.querySelector(".".concat(item.id)));
                    }
                    // 如果指定了聚焦 class
                    if (itemRender.autofocus) {
                        inputElem = el.querySelector(".".concat(item.id, " ").concat(itemRender.autofocus));
                    }
                    // 渲染器的聚焦处理
                    if (!inputElem && compConf && compConf.autofocus) {
                        inputElem = el.querySelector(".".concat(item.id, " ").concat(compConf.autofocus));
                    }
                    if (inputElem) {
                        inputElem.focus();
                        break;
                    }
                }
            }
        };
        /**
         * 校验数据
         * 按表格行、列顺序依次校验（同步或异步）
         * 校验规则根据索引顺序依次校验，如果是异步则会等待校验完成才会继续校验下一列
         * 如果校验失败则，触发回调或者 Promise<(ErrMap 校验不通过列的信息)>
         * 如果是传回调方式这返回一个 (ErrMap 校验不通过列的信息)
         *
         * rule 配置：
         *  required=Boolean 是否必填
         *  min=Number 最小长度
         *  max=Number 最大长度
         *  validator=Function({ itemValue, rule, rules, data, property }) 自定义校验，接收一个 Promise
         *  trigger=change 触发方式
         */
        var validItemRules = function (validType, fields, val) {
            var data = props.data, formRules = props.rules;
            var errorMaps = {};
            if (!XEUtils.isArray(fields)) {
                fields = [fields];
            }
            return Promise.all(fields.map(function (property) {
                var errorRules = [];
                var syncVailds = [];
                if (property && formRules) {
                    var rules_1 = XEUtils.get(formRules, property);
                    if (rules_1) {
                        var itemValue_1 = XEUtils.isUndefined(val) ? XEUtils.get(data, property) : val;
                        rules_1.forEach(function (rule) {
                            var type = rule.type, trigger = rule.trigger, required = rule.required, validator = rule.validator;
                            if (validType === 'all' || !trigger || validType === trigger) {
                                if (validator) {
                                    var validParams = {
                                        itemValue: itemValue_1,
                                        rule: rule,
                                        rules: rules_1,
                                        data: data,
                                        field: property,
                                        property: property,
                                        $form: $xeform
                                    };
                                    var customValid = void 0;
                                    if (XEUtils.isString(validator)) {
                                        var gvItem = VXETable.validators.get(validator);
                                        if (gvItem) {
                                            if (gvItem.itemValidatorMethod) {
                                                customValid = gvItem.itemValidatorMethod(validParams);
                                            }
                                            else {
                                                if (process.env.NODE_ENV === 'development') {
                                                    warnLog('vxe.error.notValidators', [validator]);
                                                }
                                            }
                                        }
                                        else {
                                            if (process.env.NODE_ENV === 'development') {
                                                errLog('vxe.error.notValidators', [validator]);
                                            }
                                        }
                                    }
                                    else {
                                        customValid = validator(validParams);
                                    }
                                    if (customValid) {
                                        if (XEUtils.isError(customValid)) {
                                            errorRules.push(new Rule({ type: 'custom', trigger: trigger, content: customValid.message, rule: new Rule(rule) }));
                                        }
                                        else if (customValid.catch) {
                                            // 如果为异步校验（注：异步校验是并发无序的）
                                            syncVailds.push(customValid.catch(function (e) {
                                                errorRules.push(new Rule({ type: 'custom', trigger: trigger, content: e ? e.message : (rule.content || rule.message), rule: new Rule(rule) }));
                                            }));
                                        }
                                    }
                                }
                                else {
                                    var isArrType = type === 'array';
                                    var isArrVal = XEUtils.isArray(itemValue_1);
                                    var hasEmpty = true;
                                    if (isArrType || isArrVal) {
                                        hasEmpty = !isArrVal || !itemValue_1.length;
                                    }
                                    else if (XEUtils.isString(itemValue_1)) {
                                        hasEmpty = eqEmptyValue(itemValue_1.trim());
                                    }
                                    else {
                                        hasEmpty = eqEmptyValue(itemValue_1);
                                    }
                                    if (required ? (hasEmpty || validErrorRuleValue(rule, itemValue_1)) : (!hasEmpty && validErrorRuleValue(rule, itemValue_1))) {
                                        errorRules.push(new Rule(rule));
                                    }
                                }
                            }
                        });
                    }
                }
                return Promise.all(syncVailds).then(function () {
                    if (errorRules.length) {
                        errorMaps[property] = errorRules.map(function (rule) {
                            return {
                                $form: $xeform,
                                rule: rule,
                                data: data,
                                field: property,
                                property: property
                            };
                        });
                    }
                });
            })).then(function () {
                if (!XEUtils.isEmpty(errorMaps)) {
                    return Promise.reject(errorMaps);
                }
            });
        };
        var showErrTime;
        var beginValidate = function (itemList, type, callback) {
            var data = props.data, formRules = props.rules;
            var validOpts = computeValidOpts.value;
            var validRest = {};
            var validFields = [];
            var itemValids = [];
            clearTimeout(showErrTime);
            if (data && formRules) {
                itemList.forEach(function (item) {
                    var field = item.field;
                    if (field && !isHiddenItem($xeform, item) && isActivetem($xeform, item)) {
                        itemValids.push(validItemRules(type || 'all', field).then(function () {
                            item.errRule = null;
                        }).catch(function (errorMaps) {
                            var rest = errorMaps[field];
                            if (!validRest[field]) {
                                validRest[field] = [];
                            }
                            validRest[field].push(rest);
                            validFields.push(field);
                            item.errRule = rest[0].rule;
                            return Promise.reject(rest);
                        }));
                    }
                });
                return Promise.all(itemValids).then(function () {
                    if (callback) {
                        callback();
                    }
                }).catch(function () {
                    return new Promise(function (resolve) {
                        showErrTime = window.setTimeout(function () {
                            itemList.forEach(function (item) {
                                if (item.errRule) {
                                    item.showError = true;
                                }
                            });
                        }, 20);
                        if (validOpts.autoPos !== false) {
                            nextTick(function () {
                                handleFocus(validFields);
                            });
                        }
                        if (callback) {
                            callback(validRest);
                            resolve();
                        }
                        else {
                            resolve(validRest);
                        }
                    });
                });
            }
            if (callback) {
                callback();
            }
            return Promise.resolve();
        };
        var validate = function (callback) {
            clearValidate();
            return beginValidate(getItems(), '', callback);
        };
        var validateField = function (fieldOrItem, callback) {
            var fields = [];
            if (XEUtils.isArray(fieldOrItem)) {
                fields = fieldOrItem;
            }
            else {
                fields = [fieldOrItem];
            }
            return beginValidate(fields.map(function (field) { return handleFieldOrItem($xeform, field); }), '', callback);
        };
        var submitEvent = function (evnt) {
            evnt.preventDefault();
            if (!props.preventSubmit) {
                clearValidate();
                beginValidate(getItems()).then(function (errMap) {
                    if (errMap) {
                        formMethods.dispatchEvent('submit-invalid', { data: props.data, errMap: errMap }, evnt);
                    }
                    else {
                        formMethods.dispatchEvent('submit', { data: props.data }, evnt);
                    }
                });
            }
        };
        var closeTooltip = function () {
            var tooltipStore = internalData.tooltipStore;
            var $tooltip = refTooltip.value;
            if (tooltipStore.visible) {
                Object.assign(tooltipStore, {
                    item: null,
                    visible: false
                });
                if ($tooltip) {
                    $tooltip.close();
                }
            }
            return nextTick();
        };
        var triggerTitleTipEvent = function (evnt, params) {
            var item = params.item;
            var tooltipStore = internalData.tooltipStore;
            var $tooltip = refTooltip.value;
            var overflowElem = evnt.currentTarget.children[0];
            var content = (overflowElem.textContent || '').trim();
            var isCellOverflow = overflowElem.scrollWidth > overflowElem.clientWidth;
            clearTimeout(internalData.tooltipTimeout);
            if (tooltipStore.item !== item) {
                closeTooltip();
            }
            if (content && isCellOverflow) {
                Object.assign(tooltipStore, {
                    item: item,
                    visible: true
                });
                if ($tooltip) {
                    $tooltip.open(overflowElem, content);
                }
            }
        };
        var handleTitleTipLeaveEvent = function () {
            var tooltipOpts = computeTooltipOpts.value;
            var $tooltip = refTooltip.value;
            if ($tooltip) {
                $tooltip.setActived(false);
            }
            if (tooltipOpts.enterable) {
                internalData.tooltipTimeout = setTimeout(function () {
                    $tooltip = refTooltip.value;
                    if ($tooltip && !$tooltip.isActived()) {
                        closeTooltip();
                    }
                }, tooltipOpts.leaveDelay);
            }
            else {
                closeTooltip();
            }
        };
        var triggerItemEvent = function (evnt, field, itemValue) {
            if (field) {
                return validItemRules(evnt ? (['blur'].includes(evnt.type) ? 'blur' : 'change') : 'all', field, itemValue)
                    .then(function () {
                    clearValidate(field);
                })
                    .catch(function (errorMaps) {
                    var rest = errorMaps[field];
                    var item = getItemByField(field);
                    if (rest && item) {
                        item.showError = true;
                        item.errRule = rest[0].rule;
                    }
                });
            }
            return nextTick();
        };
        /**
         * 更新项状态
         * 如果组件值 v-model 发生 change 时，调用改函数用于更新某一项编辑状态
         * 如果单元格配置了校验规则，则会进行校验
         */
        var updateStatus = function (scope, itemValue) {
            var field = scope.field;
            return triggerItemEvent(new Event('change'), field, itemValue);
        };
        formMethods = {
            dispatchEvent: function (type, params, evnt) {
                emit(type, Object.assign({ $form: $xeform, $grid: $xegrid, $event: evnt }, params));
            },
            reset: reset,
            validate: validate,
            validateField: validateField,
            clearValidate: clearValidate,
            updateStatus: updateStatus,
            toggleCollapse: toggleCollapse,
            getItems: getItems,
            getItemByField: getItemByField,
            closeTooltip: closeTooltip
        };
        var formPrivateMethods = {
            callSlot: callSlot,
            triggerItemEvent: triggerItemEvent,
            toggleCollapseEvent: toggleCollapseEvent,
            triggerTitleTipEvent: triggerTitleTipEvent,
            handleTitleTipLeaveEvent: handleTitleTipLeaveEvent
        };
        Object.assign($xeform, formMethods, formPrivateMethods);
        var staticItemFlag = ref(0);
        watch(function () { return reactData.staticItems.length; }, function () {
            staticItemFlag.value++;
        });
        watch(function () { return reactData.staticItems; }, function () {
            staticItemFlag.value++;
        });
        watch(staticItemFlag, function () {
            reactData.formItems = reactData.staticItems;
        });
        var itemFlag = ref(0);
        watch(function () { return props.items ? props.items.length : -1; }, function () {
            itemFlag.value++;
        });
        watch(function () { return props.items; }, function () {
            itemFlag.value++;
        });
        watch(itemFlag, function () {
            loadItem(props.items || []);
        });
        watch(function () { return props.collapseStatus; }, function (value) {
            reactData.collapseAll = !!value;
        });
        onMounted(function () {
            nextTick(function () {
                if (process.env.NODE_ENV === 'development') {
                    if (props.customLayout && props.items) {
                        errLog('vxe.error.errConflicts', ['custom-layout', 'items']);
                    }
                }
                loadItem(props.items || []);
            });
        });
        var renderVN = function () {
            var _a;
            var loading = props.loading, className = props.className, data = props.data, customLayout = props.customLayout;
            var formItems = reactData.formItems;
            // const formItems: any[] = []
            var vSize = computeSize.value;
            var tooltipOpts = computeTooltipOpts.value;
            var defaultSlot = slots.default;
            return h('form', {
                ref: refElem,
                class: ['vxe-form', className ? (XEUtils.isFunction(className) ? className({ items: formItems, data: data, $form: $xeform }) : className) : '', (_a = {},
                        _a["size--".concat(vSize)] = vSize,
                        _a['is--loading'] = loading,
                        _a)],
                onSubmit: submitEvent,
                onReset: resetEvent
            }, [
                h('div', {
                    class: 'vxe-form--wrapper vxe-row'
                }, customLayout ? (defaultSlot ? defaultSlot({}) : []) : formItems.map(function (item, index) {
                    return h(VxeFormConfigItem, {
                        key: index,
                        itemConfig: item
                    });
                })),
                h('div', {
                    class: 'vxe-form-slots',
                    ref: 'hideItem'
                }, customLayout ? [] : (defaultSlot ? defaultSlot({}) : [])),
                /**
                 * 加载中
                 */
                h(VxeLoading, {
                    class: 'vxe-form--loading',
                    modelValue: loading
                }),
                /**
                 * 工具提示
                 */
                hasUseTooltip ? h(resolveComponent('vxe-tooltip'), __assign({ ref: refTooltip }, tooltipOpts)) : createCommentVNode()
            ]);
        };
        $xeform.renderVN = renderVN;
        provide('$xeform', $xeform);
        provide('$xeformgather', null);
        provide('$xeformitem', null);
        provide('$xeformiteminfo', null);
        return $xeform;
    },
    render: function () {
        return this.renderVN();
    }
});
